
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, ExternalLink } from "lucide-react";
import { InstagramConnectionFormProps } from "./types";

const InstagramConnectionForm: React.FC<InstagramConnectionFormProps> = ({
  username,
  setUsername,
  isLoading,
  onConnect
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (username) {
      onConnect(username);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="instagram-username" className="text-sm font-medium">
          Instagram Username
        </label>
        <Input
          id="instagram-username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="your.instagram.username"
          required
        />
        <p className="text-xs text-muted-foreground">
          Enter your Instagram username to begin the connection process
        </p>
      </div>
      
      <Alert className="bg-amber-50 dark:bg-amber-950/30 border-amber-200 dark:border-amber-900">
        <AlertCircle className="h-4 w-4 text-amber-600 dark:text-amber-400" />
        <AlertDescription className="text-amber-700 dark:text-amber-400">
          In a production environment, you would be redirected to Instagram for OAuth authorization
        </AlertDescription>
      </Alert>
      
      <div className="flex flex-col space-y-2">
        <Button 
          type="submit"
          className="w-full bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600"
          disabled={isLoading || !username}
        >
          {isLoading ? "Connecting..." : "Connect Instagram Account"}
        </Button>
        
        <a 
          href="https://developers.facebook.com/docs/instagram-api/getting-started" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-xs text-muted-foreground flex items-center justify-center mt-2 hover:underline"
        >
          <ExternalLink className="h-3 w-3 mr-1" />
          Learn about Instagram API integration
        </a>
      </div>
    </form>
  );
};

export default InstagramConnectionForm;
